import { render, staticRenderFns } from "./InvestmentPlans.vue?vue&type=template&id=11daea2a&"
import script from "./InvestmentPlans.vue?vue&type=script&lang=js&"
export * from "./InvestmentPlans.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentPlans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports